module.exports = __webpack_public_path__ + "img/icon_p_i.905b2b5.svg";